import { render, staticRenderFns } from "./AddDataSource.vue?vue&type=template&id=42d0547d"
import script from "./AddDataSource.vue?vue&type=script&lang=js"
export * from "./AddDataSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports